import type { UpdateRecordsRequestDTO } from "@/application/records/dtos/RecordListItemDTO";
import { isDemoReport } from "@/lib/constants";

export const DEMO_REPORT_READ_ONLY_MESSAGE = "Demo report is read-only";

function collectMutationRecordIds(request: UpdateRecordsRequestDTO): string[] {
  return [
    ...request.change_names.map((item) => item.id),
    ...request.for_archive,
    ...request.for_delete,
    ...request.delete_link,
    ...(request.assign_link?.map((item) => item.record_id) ?? []),
    ...(request.change_status?.map((item) => item.record_id) ?? []),
  ];
}

export function assertNoDemoReportMutations(
  request: UpdateRecordsRequestDTO
): void {
  if (collectMutationRecordIds(request).some(isDemoReport)) {
    throw new Error(DEMO_REPORT_READ_ONLY_MESSAGE);
  }
}

export function assertMutableRecordId(recordId: string): void {
  if (isDemoReport(recordId)) {
    throw new Error(DEMO_REPORT_READ_ONLY_MESSAGE);
  }
}
